import { useEffect, useState } from 'react';
import { getFinanceStats, getAllPayments } from '../../services/admin';
import styles from './Admin.module.css';

export function AdminFinance() {
  const [stats, setStats] = useState<any>(null);
  const [payments, setPayments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const [s, p] = await Promise.all([getFinanceStats(), getAllPayments()]);
      setStats(s);
      setPayments(p);
      setLoading(false);
    }
    load();
  }, []);

  const statsItems = stats ? [
    { label: 'Total Revenue', value: `£${stats.totalRevenue.toFixed(2)}`, status: 'Live' },
    { label: 'Paid Users', value: stats.paidUsers.toString(), status: 'Live' },
    { label: 'Single/Family Sales', value: `${stats.singleCount} / ${stats.familyCount}`, status: 'Live' },
    { label: 'Credits Sold', value: stats.totalCreditsSold.toString(), status: 'Live' },
  ] : [
    { label: 'Total Revenue', value: '£0', status: 'Loading...' },
    { label: 'Paid Users', value: '0', status: 'Loading...' },
    { label: 'Single/Family Sales', value: '0 / 0', status: 'Loading...' },
    { label: 'Credits Sold', value: '0', status: 'Loading...' },
  ];

  return (
    <div className={styles.adminPage}>
      <header className={styles.pageHeader}>
        <div>
          <h1>Finance Overview</h1>
          <p>Financial performance and payment processing status.</p>
        </div>
        {stats && (
          <div className={styles.statusBadge} style={{ background: 'rgba(57, 255, 20, 0.1)', color: 'var(--accent)' }}>
            {stats.providerStatus}
          </div>
        )}
      </header>

      <div className={styles.statsGrid}>
        {statsItems.map((stat, i) => (
          <div key={i} className={styles.statCard}>
            <span className={styles.statLabel}>{stat.label}</span>
            <div className={styles.statValue}>{stat.value}</div>
            <div className={styles.statMeta} style={{ color: 'var(--text-3)' }}>
              {stat.status}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.adminCard} style={{ marginTop: '24px' }}>
        <h2 style={{ padding: '24px', borderBottom: '1px solid var(--border)' }}>Recent Payments</h2>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center' }}>Loading transactions...</div>
        ) : payments.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-3)' }}>No payments recorded yet.</div>
        ) : (
          <div className={styles.tableWrapper}>
            <table className={styles.adminTable}>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Plan</th>
                  <th>Amount</th>
                  <th>Credits</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((p) => (
                  <tr key={p.id}>
                    <td>{p.email}</td>
                    <td style={{ textTransform: 'capitalize' }}>{p.plan}</td>
                    <td>{p.amount} {p.currency?.toUpperCase()}</td>
                    <td>+{p.creditsAdded}</td>
                    <td>
                      <span className={styles.statusBadge} style={{ background: 'rgba(57, 255, 20, 0.1)', color: 'var(--accent)' }}>
                        {p.status}
                      </span>
                    </td>
                    <td>{p.createdAt?.toDate ? p.createdAt.toDate().toLocaleString() : 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
